module.exports = __webpack_public_path__ + "img/Icone_144.83c1b326.png";